// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.amenities.units.RentalManagerUserPropertyUnitAmenityWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyUnitAmenityCreateResponseWebDto } from '../..';

interface CreateParams {
  availableInSelectUnits?: boolean;
  floorPlanId: string;
  text: string;
}
interface DeleteParams {
  amenityId: string;
}

export const RentalManagerUserPropertyUnitAmenityWebApiHandler_create_Path =
  '/api/web/v1/users/properties/amenities/units/create';

/**
 * Create a free text unit amenity
 * @deprecated
 */
export const RentalManagerUserPropertyUnitAmenityWebApiHandler_create = (
  getParams: CreateParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CreateParams, never, UserPropertyUnitAmenityCreateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyUnitAmenityWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyUnitAmenityWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/amenities/units/delete';

/**
 * Delete a free text unit amenity
 * @deprecated
 */
export const RentalManagerUserPropertyUnitAmenityWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyUnitAmenityWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
